import React from 'react';

// eslint-disable-next-line max-len
const FLYT_LOGO = '/themes/theme/flyt/flyt-logo.png';

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre = {
  'text-align': 'center',
};

const textAlignCentre50p = {
  'text-align': 'center',
  padding: '0 50px',
};

const FLYTTheme = {
  headerLogo: {
    src: FLYT_LOGO,
    alt: 'FLYT Logo',
    size: 60,
  },
  darkLogo: {
    src: FLYT_LOGO,
    alt: 'FLYT Logo',
    size: 150,
  },
  headerStyle: {
    backgroundColor: '#272727',
    borderBottom: '4px solid #272727',
    height: 90,
  },
  linkStyle: {
    color: '#45F4DC',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'FLYT',
  isLightOnDark: true,
  organisationId: 'f065f647-ea84-47a2-a4c5-b385108aac4c',
  tokenThanksRedirectUrl: 'https://flyt-321af.web.app/#/invitacion/ok',
  tokenThanksMessage: '¡Muchas gracias!',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="180"
        src={FLYT_LOGO} alt="FLYT Logo"
      />
      <br /><br />
      {/* <h3>FLYT</h3> */}
    </div>
  ),
  shareSite: 'https://share.flytexperience.com',
  primaryButtonColorStyle: {
    background: '#45f4dc',
    color: 'white',
    margin: 5,
  },
  tagButtonColor: 'teal',
  formTitle: () => (
    <h3 style={textAlignCentre}>Crea tu perfil</h3>
  ),
  welcomeHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre50p}>Bienvenid@ a Flyt, tu asistente personal para colaboraciones</p>
      <br />
      <p style={textAlignCentre50p}>
        Únete a nuestra red y accede a las experiencias y productos que mejor se adapten a tu estilo y audiencia. 
      </p>
      <br />
      <p style={textAlignCentre50p}>
        Disfruta de una amplia selección de colaboraciones a un clic.
      </p>
      <br />
    </div>
  ),
  finishedHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>--This block is customisable--</p>
      <br />
    </div>
  ),
  socialHandle2HtmlBottom: () => (
    <h3 style={textAlignCentre}>Si no quieres añadirlas, pulsa "next"</h3>
  ),
  socialHandle3HtmlBottom: () => (
    <h3 style={textAlignCentre}>Si no quieres añadirlas, pulsa "next"</h3>
  ),
  tagsHtmlTop: () => (
    <h3 style={textAlignCentre}>
      ¿Cómo describirías el estilo de tu contenido? (Por favor, selecciona por lo menos una etiqueta)
    </h3>
  ),
};

export default FLYTTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/flyt.js
 **/